<template>
  <a :href="product_data.link" class="categorized-product">
    <div class="thumbnail" :style="style"></div>
    <h3 class="name">{{ product_data.title }}</h3>
    <p class="price">
      {{ product_data.price }}
    </p>
  </a>
</template>

<script>
export default {
  name: "CategorizedProduct",
  data() {
    return {
      quantity: 0,
      order_count: 1,
      selected_variant_id: null,
      style: {
        backgroundImage: "none",
      },
      current_image_index: 0,
    };
  },
  props: {
    product_data: {
      type: Array,
      required: false,
    },
  },
  created() {
    console.log(this.product_data);
    this.style.backgroundImage = 'url("' + this.product_data.img_src + '")';
  },
};
</script>